import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex-grow-1 min-w-0 h-full" };
const _hoisted_2 = {
    key: 0,
    class: "wrap-container flex-grow-1 min-h-0",
    style: { "overflow-x": "auto" }
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "main-content mt-0" };
const _hoisted_5 = { class: "page-header" };
const _hoisted_6 = { class: "container" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-xl-12 d-flex flex-column mx-auto" };
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { class: "main-content mt-0" };
const _hoisted_11 = { class: "page-header min-vh-80" };
const _hoisted_12 = { class: "container" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto" };
const _hoisted_15 = {
    key: 3,
    class: "scene h-100 w-100 position-absolute"
};
import { computed, ref, watch, onMounted } from "vue";
import { useAutoKitchenStore } from "@/store/AutoKitchenStore";
import FullPageFooter from "@/binaplan/components/layouts/footer/FullPageFooter.vue";
import router from "@/binaplan/router";
import User from "@/module/User";
import QueueList from "@/binaplan/components/planner/plugins/QueueList.vue";
import Planner from "@/service/Planner";
import SidebarComponent from "@/components/sidebar/SidebarComponent.vue";
import TopBar from "@/components/topbar/TopBar.vue";
import { Notifications } from "@kyvg/vue3-notification";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        // layouts
        // import MainHeader from "@/binaplan/components/layouts/header/MainHeader.vue";
        const sidebarReload = ref(0);
        const autoKitchenStore = useAutoKitchenStore();
        autoKitchenStore.getCatalog();
        autoKitchenStore.getCatalog2();
        const waitLoadingUserParams = setInterval(function () {
            if (User.getMe().id > 0) {
                sidebarReload.value++;
                clearInterval(waitLoadingUserParams);
            }
        }, 100);
        const isScene = ref(false);
        const thisNoSidebarPage = () => {
            const path = router?.currentRoute?.value?.path ?? "";
            return (!(path != "/login" &&
                path != "/signup" &&
                path != "/404" &&
                path != "/tools/model") ||
                (router?.currentRoute?.value.path === "/" &&
                    typeof router?.currentRoute?.value.name === "undefined"));
        };
        const isOtherPage = computed(() => {
            const path = router.currentRoute.value.path;
            return path == "/tools/model";
        });
        const pageLayout = ref();
        const isShowSidebar = ref(false);
        function showSidebar() {
            isShowSidebar.value = !isShowSidebar.value;
        }
        //const isLoginPage = computed((): boolean => thisNoSidebarPage());
        const isLoginPage = ref(true);
        onMounted(async () => {
            watch(() => router.currentRoute.value, () => {
                isLoginPage.value = thisNoSidebarPage();
                const minifySidebar = router.currentRoute.value.meta.minifySidebar;
                if (minifySidebar) {
                    pageLayout.value?.classList.add("minify-sidebar");
                }
                else {
                    pageLayout.value?.classList.remove("minify-sidebar");
                }
            }, { flush: "post", immediate: true } // immediate чтобы отработало при первом заходе
            );
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "page-layout flex h-full overflow-hidden",
                    style: { "padding": "0.875rem 0 0.875rem 0.875rem" },
                    ref_key: "pageLayout",
                    ref: pageLayout
                }, [
                    (!isLoginPage.value)
                        ? (_openBlock(), _createBlock(SidebarComponent, {
                            key: 0,
                            class: "flex-shrink-0"
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_1, [
                        (!isLoginPage.value)
                            ? (_openBlock(), _createElementBlock("main", {
                                key: 0,
                                class: _normalizeClass([{
                                        'max-height-vh-100': isScene.value,
                                        'vh-100  ps ps--active-y': isScene.value,
                                        'active-sidebar': isShowSidebar.value,
                                    }, "main-content h-full flex flex-grow-1 flex-column position-relative border-radius-lg"])
                            }, [
                                _createVNode(TopBar),
                                (!isLoginPage.value && !isScene.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode(_component_router_view)
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : (isOtherPage.value)
                                ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("section", null, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createElementVNode("div", _hoisted_8, [
                                                            _createVNode(_component_router_view)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createVNode(FullPageFooter)
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("main", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("section", null, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("div", _hoisted_14, [
                                                            _createVNode(_component_router_view)
                                                        ]),
                                                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-6" }, [
                                                            _createElementVNode("div", { class: "oblique position-absolute top-0 h-100 d-md-block d-none me-n8" }, [
                                                                _createElementVNode("div", {
                                                                    class: "oblique-image bg-cover position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6",
                                                                    style: { "background-image": "url('/assets/images/curved-images/background-form-2.jpg')" }
                                                                })
                                                            ])
                                                        ], -1))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createVNode(FullPageFooter)
                                    ])
                                ])),
                        (!isLoginPage.value && isScene.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_router_view)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ], 512),
                _createVNode(_unref(Notifications)),
                (_openBlock(), _createBlock(QueueList, {
                    key: _unref(Planner).queueCount
                }))
            ], 64));
        };
    }
});
